import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'BundleChunk',
        path: () => path.join(__dirname, './Bundle'),
        resolve: () => require.resolveWeak('./Bundle'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "BundleChunk" */ './Bundle')]).then(
                (proms) => proms[0]
            ),
    })
);
